import useAuth from 'hooks/useAuth'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Flex } from '../../styling/GlobalStyles'
import { ErrorWrapper } from './Error.styled'
import { TitleText } from 'styling/Typography'
import { AimLogoPale } from 'assets/icons/AimLogoPale'

export const Error: React.FC = () => {
  const { isAdmin } = useAuth()
  const navigate = useNavigate()

  const findRedirect = () => {
    if (isAdmin) {
      return 'operations'
    }
    return 'hr/employees'
  }

  return (
    <ErrorWrapper>
      <Flex column height='100%' justcenter >
        <AimLogoPale />
        <TitleText weight='bold' >Page not found</TitleText>
        <Button onClick={() => navigate(findRedirect())}>Go back</Button>
      </Flex>
    </ErrorWrapper>
  )
}
